import { render } from "./notification.vue?vue&type=template&id=63d9bb6a"
import script from "./notification.vue?vue&type=script&lang=js"
export * from "./notification.vue?vue&type=script&lang=js"

import exportComponent from "/Users/Serik/Job/qbox-transcriber-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__